/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { z } from 'zod/v4'

export const scheduleOverrideRequestSchema = z.object({
	from: z.string(),
	to: z.string(),
	open: z.boolean(),
	start: z.string().nullable().optional(),
	end: z.string().nullable().optional(),
})

export type ScheduleOverrideRequestSchema = z.infer<typeof scheduleOverrideRequestSchema>
